import { render, staticRenderFns } from "./training-plan-kanban.vue?vue&type=template&id=032c8a99&scoped=true"
import script from "./training-plan-kanban.vue?vue&type=script&lang=js"
export * from "./training-plan-kanban.vue?vue&type=script&lang=js"
import style0 from "./training-plan-kanban.vue?vue&type=style&index=0&id=032c8a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c8a99",
  null
  
)

export default component.exports